import { Component, EventEmitter,ViewChild,Output,ElementRef} from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { DatePipe } from "@angular/common";
import { MessagesGeneral,MessagesTitles,MessagesStatus} from '../../../models/messages';
import { ReportesService } from '../../../services/reportes/reportes.service';
import { exportJsonToExcel } from 'app/shared/servifin-excel.export';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-detalle-pago-adq',
  templateUrl: './detalle-pago-adq.component.html',
  styleUrls: ['./detalle-pago-adq.component.scss'],
  providers:[DatePipe,MessagesTitles,MessagesGeneral,MessagesStatus]
})
export class DetallePagoAdqComponent{
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @Output() cerrarPop : EventEmitter<boolean> = new EventEmitter();

  idDesembolso:any;
  dataReporte:any = [];
  dataSource:any = [];
  footerTotal : number = 0;
  count : number = 0;
  

  @ViewChild('TABLE',{static: true}) table: ElementRef;
  displayedColumns: string[] = ['idCobranza','Serie','Numero','Tipo_Pago','Prov_RS','Adq_RS','Moneda','Pago_Importe','Fecha_Pago','Fondeador','FIE']

  constructor(private reporteService:ReportesService) {
      this.idDesembolso = this.reporteService.idDesembolso;
      this.dataReporte = this.reporteService.datos;
      this.dataSource = new MatTableDataSource(this.dataReporte)

    for (let item of this.dataReporte){
      this.footerTotal += Number(item.Pago_Importe)
    }
     }

  ExportToExcel(){
    this.count +=1;
    let exportExcel : any = [];
    exportExcel = this.dataReporte;

    if(this.count==1){
      let add = {'Codigo_Planilla':'','idCobranza':'','idCabecera':'','Tipo_Pago':'','idProveedor':'','Prov_RS':'','Prov_RUC':'','idAdquirente':'','Adq_RS':'','Adq_RUC':'',
      'Moneda':'','Deposito_Importe':'','Serie':'','Numero':'Total','Pago_Importe': this.footerTotal,'Fecha_Pago':'','Fondeador':'','FIE':''}
      exportExcel.push(add);
    }

    const fecha = new Date().toISOString().substring(0, 10);
    const filename = `PlanillaPagoAdquirentes-${this.dataReporte[0].Codigo_Planilla}-${fecha}.xlsx`;
    exportJsonToExcel(exportExcel, 'Sheet1', '', filename);
  }

  getTotal() {
    this.footerTotal = this.dataReporte.map(t => t.Pago_Importe).reduce((acc, value) => acc + value, 0);
    return this.footerTotal;
  }

  CerrarPopUp(){
    this.cerrarPop.emit();
  }
}
